import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AddressService {
  urlGateway = environment.api_gateway;
  url = environment.url;

  constructor(
    private http: HttpClient
  ) { }

  cleanCep(cep: string): string {
    if (!cep) return '';

    return cep.replace(/\D/g, "");
  }

  getAddressByCep(cep = ''): Observable<any> {
    return this.http.get<any>(`${this.url}/public/third-party/get-address?cep=${this.cleanCep(cep)}`);
  }

  getGeolocation(params = {}): Observable<any> {
    return this.http.post<any>(`${this.urlGateway}/api/users/address/geolocation/v1/`, params);
  }
}
